import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import "../../../../App.css";

export default function ProfileModel(props) {
    const navigate = useNavigate();
    const LogOutHandler = () => {
        localStorage.removeItem("userInfo");
        toast.success('Log out Sucessfull!', {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
        });
        navigate("/");
    }
    return (

        <div style={{ display: "flex", justifyContent: "space-between", paddingTop: "10px", flexWrap: "wrap" }}>

            <div style={{ display: "flex", alignItems: "center" }}>
                <img src={props?.pic} alt="" style={{ width: "100px", borderRadius: "50%", margin: "15px" }} />
                <div>
                    <h2 className='text' style={{ margin: "1px" }}>Welcome  <span style={{ color: "GrayText" }}>{props?.name}
                        <i className="bi bi-box-arrow-right" style={{ fontSize: "25px", color: "red", margin: "5px 10px", cursor: "pointer" }} onClick={LogOutHandler}></i>
                    </span></h2>
                    <p className='text'> {props?.email}</p>
                </div>
            </div>

        </div>
    )
}
